// import UserPage from "src/pages/UserPage.vue";
const routes = [
  {
    path: "/",
    component: () => import("layouts/AuthLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/LoginPage.vue"),
        name: "index",
      },
    ],
  },
  {
    path: "/trip-task",
    component: () => import("layouts/MainLayout.vue"),
    children: [
      {
        path: "",
        component: () => import("pages/TripTask.vue"),
        name: "trip-task",
      },
      {
        path: "/users",
        component: () => import("pages/User.vue"),
        name: "users",
      },
      {
        path: "/beats",
        component: () => import("pages/BeatPage.vue"),
        name: "beats",
      },
    ],
  },

  {
    path: "/:catchAll(.*)*",
    component: () => import("pages/ErrorNotFound.vue"),
  },
];

export default routes;
